import { Record, Map } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { ProfileSectionTypeLabel } from 'enums/profile-section-type';

const ProfileSectionRecord = Record({
  section: '',
  data: Map(),
  completed: false,
  score: Map(),
  updateRequested: false,
  hasProfileAttachment: false,
  network: { loading: false, error: false },
  profileId: undefined,
});

export default class ProfileSection extends ProfileSectionRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new ProfileSection(hydrated);
  }

  get id() {
    return this.section;
  }

  get title() {
    return ProfileSectionTypeLabel[this.section];
  }
}
